import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  margin: 0;
  text-align: center;
`;
